export interface DashboardContextFromUrl {
	cloudId: string;
	dashboardId: string;
}

/**
 * Pattern for dashboard page path: /o/:cloudId/s/:siteId/d/:dashboardId
 * siteId = cloudId
 */
const DASHBOARD_PATH_REGEX = /^\/o\/([^/]+)\/s\/([^/]+)\/d\/([^/]+)(?:\/|$)/;

export function getDashboardContextFromUrl(): DashboardContextFromUrl | null {
	if (typeof window === 'undefined' || !window.location?.pathname) {
		return null;
	}
	const pathname = window.location.pathname;
	const match = pathname.match(DASHBOARD_PATH_REGEX);
	if (!match) {
		return null;
	}
	const [, , cloudId, dashboardId] = match;
	if (!cloudId || !dashboardId) {
		return null;
	}
	return { cloudId, dashboardId };
}

/**
 * Returns true when the current URL matches a dashboard page path.
 */
export function isOnDashboardPage(): boolean {
	return getDashboardContextFromUrl() !== null;
}
